import { useMutation } from "@tanstack/react-query";
import { approveCustomValuesByType } from "PFCore/services/admin/custom_values";
import { MutationOptions } from "PFTypes/request_options";

import { useCustomValuesInvalidate } from "../use_custom_values_invalidate";
import { CustomValueBulkParams } from "./params";
import { CustomValueBulkResponse } from "./response";

export const useApproveCustomValues = ({
  onSuccess,
  ...queryParams
}: MutationOptions<CustomValueBulkParams> = {}) => {
  const { invalidate } = useCustomValuesInvalidate();

  return useMutation({
    mutationFn: ({ customTypeId, ids }: CustomValueBulkParams): Promise<CustomValueBulkResponse> =>
      approveCustomValuesByType(customTypeId, ids),
    onSuccess: (...args) => {
      invalidate();
      onSuccess?.(...args);
    },
    ...queryParams
  });
};
